<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <!-- Navbar -->
    <HeaderMenu/>
    <!-- End Navbar -->
    <main class="main-content mt-0">
      <section>
        <div class="page-header min-vh-100">
          <div class="container">
            <div class="row d-flex justify-content-center">
              <div class="col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0 mx-auto">
                <div class="card card-plain border-1 border-radius-2xl">
                  <div class="card-header pb-0 text-start">
                    <h4 class="font-weight-bolder">Acceso a DOOX</h4>
                    <p class="mb-0">Introduce tu usuario y contraseña para acceder</p>
                  </div>
                  <div class="card-body" style="background-color: white">
                    <form @submit.prevent="handleLogin">
                      <div class="mb-3">
                        <label for="username" class="form-label">Usuario</label>
                        <input 
                          id="username" 
                          type="text" 
                          class="form-control form-control-lg" 
                          placeholder="Usuario" 
                          v-model="credentials.username" 
                          aria-label="Usuario" 
                          required
                          :disabled="isLoading"
                        />
                      </div>
                      <div class="mb-3">
                        <label for="password" class="form-label">Contraseña</label>
                        <input 
                          id="password" 
                          type="password" 
                          class="form-control form-control-lg" 
                          placeholder="Contraseña" 
                          v-model="credentials.password" 
                          aria-label="password" 
                          required
                          :disabled="isLoading"
                        />
                      </div>
                      <div class="text-center">
                        <button 
                          type="submit" 
                          class="btn btn-lg btn-primary w-100 mt-4 mb-0"
                          :disabled="isLoading"
                        >
                          <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          {{ isLoading ? 'Iniciando sesión...' : 'Acceder' }}
                        </button>
                      </div>
                    </form>
                    
                    <!-- Mensajes de error -->
                    <div v-if="error" class="alert alert-danger mt-3">
                      <i class="fas fa-exclamation-triangle me-2"></i>
                      {{ error }}
                    </div>
                    
                    <!-- Mensajes de éxito -->
                    <div v-if="success" class="alert alert-success mt-3">
                      <i class="fas fa-check-circle me-2"></i>
                      {{ success }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu.vue";
import { reactive, onMounted } from "vue";
import { useAuth } from "@/composables/useAuth";

export default {
  name: "LoginView",
  components: { HeaderMenu },
  setup() {
    const { login, isLoading, error, success, clearMessages, redirectIfAuthenticated } = useAuth();
    
    // Credenciales del formulario
    const credentials = reactive({
      username: '',
      password: ''
    });

    // Manejar el login
    const handleLogin = async () => {
      clearMessages();
      
      // Validación básica
      if (!credentials.username || !credentials.password) {
        return;
      }

      const result = await login(credentials);
      
      if (result.success) {
        // El login fue exitoso, la redirección se maneja en el composable
        credentials.username = '';
        credentials.password = '';
      }else{
        error.value = result.error;
        credentials.username = '';
        credentials.password = '';
      }
    };

    // Redirigir si ya está autenticado
    onMounted(async () => {
      await redirectIfAuthenticated();
    });

    return {
      credentials,
      isLoading,
      error,
      success,
      handleLogin,
      clearMessages
    };
  },
};
</script>

<style scoped>
.min-vh-100 {
  min-height: 100vh;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
  border-radius: 0.25rem;
  padding: 0.75rem 1.25rem;
}
</style>
